export default "__VITE_ASSET__CmI98MC6__"